<script>
    export let current_page;
    export let last_page;
    export let from;
    export let to;
    export let total;
    export let max_buttons = 10;
    let close_page = max_buttons / 2;
    let start_page,
        number_list = [],
        total_buttons = max_buttons;

    $: if (max_buttons > last_page) total_buttons = last_page;
    else total_buttons = max_buttons;
    $: if (current_page > last_page) current_page = last_page;
    $: start_page = current_page - close_page > 0 ? (current_page - close_page > last_page - total_buttons ? last_page - total_buttons + 1 : current_page - close_page + 1) : 1;

    const range = (size, startAt = 0) => [...Array(size).keys()].map((i) => i + startAt);

    $: number_list = range(total_buttons, start_page);

    function changePage(page) {
        current_page = page;
    }
</script>

<div class="row">
    <div class="col-4">
        <p>
            Page {current_page} of {last_page} ({from + 1} - {to} on {total} items)
        </p>
    </div>
    <div class="col-8">
        <nav>
            <ul class="pagination  justify-content-end">
                <li class="page-item {current_page === 1 ? 'disabled' : ''}">
                    <a class="page-link user-select-none" href="!" on:click|preventDefault={() => changePage(1)}>
                        <span aria-hidden="true"><i class="bi bi-skip-start-fill" /></span>
                    </a>
                </li>
                <li class="page-item user-select-none {current_page === 1 ? 'disabled' : ''}">
                    <a class="page-link" href="!" on:click|preventDefault={() => changePage(current_page - 1)}>
                        <span aria-hidden="true"><i class="bi bi-skip-backward-fill" /></span>
                    </a>
                </li>
                {#each number_list as page, i}
                    <li class="page-item user-select-none {page === current_page ? 'active' : ''}">
                        <a class="page-link" href="!" on:click|preventDefault={() => changePage(page)}>{page}</a>
                    </li>
                {/each}
                <li class="page-item {current_page === last_page ? 'disabled' : ''}">
                    <a class="page-link user-select-none" href="!" on:click|preventDefault={() => changePage(current_page + 1)}>
                        <span aria-hidden="true"><i class="bi bi-skip-forward-fill" /></span>
                    </a>
                </li>
                <li class="page-item {current_page === last_page ? 'disabled' : ''}">
                    <a class="page-link user-select-none" href="!" on:click|preventDefault={() => changePage(last_page)}>
                        <span aria-hidden="true"><i class="bi bi-skip-end-fill" /></span>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</div>

<style>
    .page-item {
        width: 40px;
        text-align: center;
    }

    .page-link:focus {
        outline: none;
        box-shadow: none;
    }
</style>
